function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 4209",
  fill: "#ce1212"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 5336",
  d: "M30.925 14.183c-.913 0-2.121-.02-3.624-.02a6.741 6.741 0 01-6.686-6.739v-6.5A.921.921 0 0019.7 0H9.017A9.069 9.069 0 000 9.108v21.766A9.48 9.48 0 009.434 40.4h15.91a9.041 9.041 0 009-9.086V15.092a.917.917 0 00-.915-.925c-.858.005-1.882.016-2.504.016z",
  opacity: 0.4
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 5337",
  d: "M25.42 1.145a.964.964 0 00-1.656.675v5.327a4.091 4.091 0 004.07 4.072c1.41.016 3.365.02 5.026.016a.964.964 0 00.693-1.632z",
  opacity: 0.4
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 5338",
  d: "M23.443 21.632a1.5 1.5 0 00-2.129 0l-3.212 3.23v-9.754a1.507 1.507 0 00-3.01 0v9.751l-3.21-3.225a1.504 1.504 0 00-2.133 2.121l5.783 5.812a1.5 1.5 0 002.127 0l5.781-5.81a1.5 1.5 0 000-2.127z"
}));

function SvgSoftwareDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.34,
    height: 40.4,
    viewBox: "0 0 34.34 40.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwareDownload);
export default __webpack_public_path__ + "static/media/software-download.226862be.svg";
export { ForwardRef as ReactComponent };